export default ({ FONT_SIZES }) => ({
  container: {
    position: 'relative'
  },
  updatingOverlay: {
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: '100'
  },
  dateCell: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end'
  },
  resetPass: {
    display: 'block'
  },
  daySelect: {
    width: '100%'
  },
  submitHolder: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
    alignItems: 'center',
    ...FONT_SIZES.HEADING_LARGE.STYLE
  },
  groupAddHintCell: {
    justifyContent: 'flex-start',
    paddingTop: '26px'
  },
  groupAddCell: {
    justifyContent: 'flex-start',
    paddingTop: '26px'
  },
  groupAddButton: {
    textAlign: 'center',
    display: 'block'
  }
})
